import React, { memo, useMemo } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { areEqual } from 'Utils/equalityChecks';
import { useCustomReports } from 'Context/CustomReports';
import { ReportCard } from '../ReportCard/ReportCard';
import classes from './projectsOverTime.module.css';

function ProjectsOverTime() {
  const { projectsOverTime }: any = useCustomReports();
  const { data, loading, error } = projectsOverTime;

  const chartData = useMemo(() => {
    if (!data || data.length === 0) return [];

    const counts: Record<string, number> = {};
    data.forEach((row: any) => {
      const createdAt = row['project.created_at'];
      if (!createdAt) return;
      const date = new Date(createdAt);
      const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      counts[monthKey] = (counts[monthKey] || 0) + 1;
    });

    return Object.entries(counts)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([month, count]) => ({ month, count }));
  }, [data]);

  return (
    <ReportCard
      title="Projects Over Time"
      subtitle="Project creation trend by month"
      loading={loading}
      error={error}
      configKey="projectsOverTime"
    >
      {chartData.length > 0 ? (
        <div className={classes.chartWrapper}>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" tick={{ fontSize: 12 }} />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Line type="monotone" dataKey="count" stroke="#9A00FF" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <p className={classes.emptyState}>No project timeline data available.</p>
      )}
    </ReportCard>
  );
}

const ProjectsOverTimeMemo = memo(ProjectsOverTime, areEqual);
export { ProjectsOverTimeMemo as ProjectsOverTime };
